"use strict";

exports.__esModule = true;
exports.transitionTransformer = exports.heightTransformer = void 0;

var _ramda = require("ramda");

var _styles = require("@qc-modules/styles");

var heightTransformer = function heightTransformer(value) {
  if (value > 0 && value <= 1) {
    return (value * 100).toFixed(1) + "%";
  }

  if ((0, _ramda.is)(Number, value) && value > 1 || value === 0) {
    return value + "px";
  }

  return value;
};

exports.heightTransformer = heightTransformer;

var transitionTransformer = function transitionTransformer(value) {
  var duration = value[0],
      properties = value.slice(1);
  return (0, _styles.transitionEase)(duration, properties);
};

exports.transitionTransformer = transitionTransformer;